module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/62cfab30281b265d9e64dc417c9e9b79.png";